import { render, staticRenderFns } from "./Crop.vue?vue&type=template&id=a37cc556&scoped=true"
import script from "./Crop.vue?vue&type=script&lang=js"
export * from "./Crop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37cc556",
  null
  
)

export default component.exports